export default __webpack_public_path__ + "static/media/background_dots.c2bd75f1.png";